import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { AVATAR_COLORS } from './constants';

dayjs.extend(relativeTime);

export function getInitials(firstName = '', lastName = '') {
  const a = (firstName || '').trim().charAt(0);
  const b = (lastName || '').trim().charAt(0);
  return `${a}${b}`.toUpperCase() || '?';
}

export function agentDisplayName(agent) {
  if (!agent) return 'Unknown';
  return `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || 'Unknown';
}

export function avatarColorFromId(id) {
  if (!id) return AVATAR_COLORS[0];
  let hash = 0;
  const str = String(id);
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash + str.charCodeAt(i) * (i + 1)) % AVATAR_COLORS.length;
  }
  return AVATAR_COLORS[hash];
}

export function formatRelative(date) {
  if (!date) return '—';
  const d = dayjs(date);
  const diffMin = dayjs().diff(d, 'minute');
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = dayjs().diff(d, 'hour');
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = dayjs().diff(d, 'day');
  if (diffDay < 7) return `${diffDay}d ago`;
  return d.fromNow();
}

export function formatExact(date) {
  if (!date) return '—';
  return dayjs(date).format('D MMM · HH:mm');
}

export function formatLiveStamp(date) {
  if (!date) return '';
  return `updated ${dayjs(date).format('D MMM · HH:mm')}`;
}

export function formatTrend(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return '0%';
  const n = Number(value);
  if (n > 0) return `+${n}%`;
  return `${n}%`;
}

export function chartLabel(dateStr, index, total) {
  if (total <= 7) return dayjs(dateStr).format('D MMM');
  if (total <= 14) {
    return index % 2 === 0 ? dayjs(dateStr).format('D MMM') : '';
  }
  return index % 5 === 0 || index === total - 1
    ? dayjs(dateStr).format('D MMM')
    : '';
}

export function parsePeriodDays(value, fallback = 30) {
  const n = parseInt(value, 10);
  if ([7, 14, 30].includes(n)) return n;
  return fallback;
}

export function parsePage(value, fallback = 1) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}
